import { createBrowserRouter } from "react-router-dom";

import { PageOutlet } from "@/components/Page/PageOutlet";
import { Dashboard } from "../pages/Dashboard/Dashboard";
import LocalLogin from "../pages/LocalLogin";
import { PrivateSection } from "../components/PrivateSection/PrivateSection";
import { ErrorBoundary } from "../components/ErrorBoundary/ErrorBoundary";
import { PaymentMethods } from "../pages/PaymentMethods";
import { Invoice } from "../pages/Invoice";
import { slugs } from "./slugs";
import { Invoices } from "../pages/Invoices/Invoices";
import { PayInvoices } from "../pages/PayInvoices/PayInvoices";
import { CreateSecurityDeposit } from "../pages/SecurityDeposit/CreateSecurityDeposit";

// we provide a login page locally to be able to use/develop the portal
// (on prod, the auth token is shared with the member portal because the app is served on the same domain)
const loginRoute =
  import.meta.env.VITE_ENABLE_LOGIN_PAGE === "true"
    ? [{ path: slugs.login, Component: LocalLogin }]
    : [];

export const router = createBrowserRouter(
  [
    {
      ErrorBoundary,
      path: "/",
      children: [
        ...loginRoute,
        {
          Component: PrivateSection,
          // no path here, that is normal, we just want to wrap
          // all children in the PrivateSection component
          // @see https://reactrouter.com/en/main/route/route#layout-routes
          children: [
            {
              Component: PageOutlet,
              children: [
                {
                  index: true,
                  Component: Dashboard,
                },
                {
                  path: slugs.paymentMethods,
                  Component: PaymentMethods,
                },
                {
                  path: slugs.allInvoices,
                  Component: Invoices,
                },
                {
                  path: slugs.payInvoices,
                  Component: PayInvoices,
                },
                {
                  path: slugs.invoice,
                  Component: Invoice,
                },
                {
                  path: slugs.securityDeposit,
                  Component: CreateSecurityDeposit,
                },
                // put all the other routes that require to be logged in here
              ],
            },
          ],
        },
      ],
    },
  ],
  {
    basename: import.meta.env.VITE_CONTENT_ROOT,
  }
);
